import React from "react";

const AuthenticatingIndicator: React.FC = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-primary-extraLight">
      {/* A heading, not a button: it names the page and does nothing when pressed. */}
      <h1 className="animate-pulse rounded-md bg-primary px-4 py-2 text-white motion-reduce:animate-none">
        Authenticating...
      </h1>
    </div>
  );
};

export default AuthenticatingIndicator;
